import { required } from 'utils/errorsTextHelper';
import * as yup from 'yup';

export const completedValidationSchema = yup.object().shape({
  purchaseCompletedModal: yup.object().shape({
    color: yup.object().shape({
      colorOne: yup.string().required(required('Button main color')),
      colorTwo: yup.string()
    }),
    size: yup
      .number()
      .min(26, 'Text size is minimum 26')
      .max(40, 'Text size is maximum 40'),
    text: yup.string().required(required('Header')),
    weight: yup.string().required(required('Header font weight'))
  }),
  additionalText: yup.object().shape({
    color: yup.string(),
    size: yup
      .number()
      .min(12, 'Text size is minimum 12')
      .max(24, 'Text size is maximum 24'),
    text: yup.string(),
    weight: yup.string()
  }),
  productsQuantity: yup.object().shape({
    color: yup.string(),
    size: yup
      .number()
      .transform((value, originalValue) =>
        originalValue === '' || originalValue === null ? undefined : value
      )
      .nullable()
      .min(10, 'Text size is minimum 10')
      .max(32, 'Text size is maximum 32'),
    weight: yup.string()
  }),
  backgroundOpacity: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === '' || originalValue === null ? undefined : value
    )
    .nullable()
    .min(0, 'Opacity is minimum 0')
    .max(100, 'Opacity is maximum 100'),
  closeIcon: yup.string(),
  backToGameButton: yup.object().shape({
    image: yup.string(),
    text: yup.string().required(required('Back to game text'))
  }),
  deepLinks: yup.object().shape({
    ios: yup
      .string()
      .matches(/.+:\/\/.*/, 'Apple deep link must be a valid url'),
    android: yup
      .string()
      .matches(/.+:\/\/.*/, 'Android deep link must be a valid url'),
    web: yup.string().matches(/.+:\/\/.*/, 'Web deep link must be a valid url')
  })
});
